export default "__VITE_ASSET__CpozQIUn__"